/* Video uses the active device source only. Respects reduced motion. */
(() => {
  const setup = (root = document) => {
    root.querySelectorAll('[data-ah-hero]').forEach(hero => {
      if (hero.dataset.ready) return;
      hero.dataset.ready = 'true';
      const video = hero.querySelector('video'), button = hero.querySelector('[data-ah-film-toggle]');
      if (!video || !button) return;
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      const source = [...video.querySelectorAll('source')].find(s => matchMedia(s.media).matches);
      if (source) video.src = source.dataset.src;
      const update = () => { const playing = !video.paused; video.toggleAttribute('data-playing', playing); button.textContent = playing ? 'Pause film' : 'Play film'; button.setAttribute('aria-label', playing ? 'Pause background video' : 'Play background video'); };
      video.addEventListener('playing',update);video.addEventListener('pause',update);
      button.addEventListener('click', () => { if (video.paused) video.play().catch(()=>{}); else video.pause(); });
      if (!reduce.matches) video.play().catch(()=>{});
      reduce.addEventListener('change', e => { if(e.matches) video.pause(); });
    });
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',()=>setup()); else setup();
  document.addEventListener('shopify:section:load',e=>setup(e.target));
})();
if (!customElements.get('ahmera-buy-bar')) customElements.define('ahmera-buy-bar', class extends HTMLElement {
  connectedCallback() {
    this.main = document.querySelector('product-info[id^="MainProduct-"]');
    if(!this.main) return;
    this.button = this.querySelector('[data-ah-bar-submit]');
    this.sync = () => {
      const form = this.main.querySelector('product-form form[data-type="add-to-cart-form"]');
      const submit = form?.querySelector('[type="submit"]');
      if(!submit) {this.hidden = true; return;}
      this.button.disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
      this.button.textContent = submit.querySelector('span')?.textContent.trim() || 'Add to cart';
      const price = this.main.querySelector('.price');
      const active = price?.classList.contains('price--on-sale') ? price.querySelector('.price__sale .price-item--sale') : price?.querySelector('.price__regular .price-item');
      this.querySelector('[data-ah-bar-price]').textContent = active?.textContent.trim() || '';
    };
    this.click = () => { this.sync(); if(this.button.disabled) return; const form = this.main.querySelector('product-form form[data-type="add-to-cart-form"]'); form?.requestSubmit(form.querySelector('[type="submit"]')); };
    this.button.addEventListener('click',this.click);
    this.mutation = new MutationObserver(this.sync); this.mutation.observe(this.main,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','aria-disabled','class']});
    this.visibility = () => {
      if(this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        const target = this.main.querySelector('.product-form__buttons');
        this.hidden = !target || target.getBoundingClientRect().bottom > 0;
      });
    };
    window.addEventListener('scroll',this.visibility,{passive:true});
    window.addEventListener('resize',this.visibility);
    this.visibility();
    document.body.classList.add('ah-has-buybar');this.sync();
  }
  disconnectedCallback(){this.mutation?.disconnect();window.removeEventListener('scroll',this.visibility);window.removeEventListener('resize',this.visibility);cancelAnimationFrame(this.frame);this.button?.removeEventListener('click',this.click);document.body.classList.remove('ah-has-buybar');}
});
